<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="link-arrow"
  >
    <path
      d="M17.6345 13.2492C18.1218 13.5989 18.1218 14.4011 17.6345 14.7508L11.2128 19.3594C10.6875 19.7365 10 19.3109 10 18.6086L10 9.39142C10 8.68915 10.6875 8.26355 11.2128 8.64058L17.6345 13.2492Z"
      fill=""
    />
  </svg>
</template>
<script>
export default {
  name: 'LinkArrow'
}
</script>
<style lang="sass">
.link-arrow
  fill: currentColor
</style>
